import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "column",
    marginTop: 20,
    marginBottom: 10,
    
    // paddingHorizontal: 20,
    // paddingVertical: 10,
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.5,
    textAlign: "left", // Ensuring left alignment of text
  },
    impotentTitle: {
        fontSize: 10,
        lineHeight: 1.5,
        textAlign: "left", // Ensuring left alignment of text
        fontWeight: "bolder",
        marginBottom: 3, // Adding space below the title
    },
});

const InvoiceEmergency = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.impotentTitle}>Important Notes:</Text>
    <Text style={styles.reportTitle}>
      • The hotel owner or experience provider may request a copy of your
      passport upon check in. {"\n"}• To avoid unnecessary charges please ensure
      that you are familiar with the service providers’ cancellation policy.{" "}
      {"\n"}• We strive to provide you with a quality service. If you see
      yourself not getting the service that you deserve, please do give a call
      to our emergency number provided.
    </Text>
  </View>
);

export default InvoiceEmergency;
